import React from 'react';

const EmailSvgIcon = (props) => (
  <svg
    width="70"
    height="61"
    viewBox="0 0 70 61"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.8"
      d="M41.845 20.8522H27.6783C26.6783 20.8522 26.0116 21.5189 26.0116 22.5189C26.0116 23.5189 26.6783 24.1855 27.6783 24.1855H41.845C42.845 24.1855 43.5116 23.5189 43.5116 22.5189C43.5116 21.5189 42.845 20.8522 41.845 20.8522ZM46.845 10.6855H22.845C21.845 10.6855 21.1783 11.3522 21.1783 12.3522C21.1783 13.3522 21.845 14.0189 22.845 14.0189H47.0116C48.0116 14.0189 48.6783 13.3522 48.6783 12.3522C48.6783 11.3522 47.845 10.6855 46.845 10.6855ZM64.0116 22.1855L60.6783 24.1855V6.85221C60.6783 3.18555 57.6783 0.185547 54.0116 0.185547H15.845C12.1783 0.185547 9.1783 3.18555 9.1783 6.85221V24.3522L5.84497 22.3522C3.6783 21.0189 0.844971 22.6855 0.844971 25.1855V55.1855C0.844971 58.0189 3.01164 60.1855 5.84497 60.1855H64.1783C67.0116 60.1855 69.1783 58.0189 69.1783 55.1855V25.0189C69.0116 22.5189 66.1783 20.8522 64.0116 22.1855ZM57.1783 26.1855L37.345 38.1855C35.6783 39.1856 33.845 39.1856 32.1783 38.1855L12.345 26.1855V6.85221C12.345 5.01888 13.845 3.51888 15.6783 3.51888H53.845C55.6783 3.51888 57.1783 5.01888 57.1783 6.85221V26.1855Z"
      fill="#DBDEE2"
    />
  </svg>
);

export default EmailSvgIcon;
